// Tıkla-gönder: WhatsApp / SMS uygulamasını hazır mesaj ve numarayla açar (ücretsiz, API gerekmez)

export const normalizePhone = (raw) => {
  let d = String(raw || '').replace(/\D/g, '');
  if (d.startsWith('00')) d = d.slice(2);
  if (d.length === 11 && d.startsWith('0')) d = `90${d.slice(1)}`;
  if (d.length === 10 && d.startsWith('5')) d = `90${d}`;
  return d.length >= 11 ? d : '';
};

export const messageUrl = (channel, phone, text) => {
  const p = normalizePhone(phone);
  if (!p) return '';
  const t = encodeURIComponent(text || '');
  return channel === 'sms' ? `sms:+${p}?&body=${t}` : `https://wa.me/${p}?text=${t}`;
};

export const NO_PHONE_MSG = 'Geçerli bir telefon numarası yok (ör. 05xx xxx xx xx)';

// Numara ve metin hazırsa doğrudan aç
export const openMessage = (channel, phone, text) => {
  const url = messageUrl(channel, phone, text);
  if (!url) throw new Error(NO_PHONE_MSG);
  if (channel === 'sms') window.location.href = url;
  else window.open(url, '_blank', 'noopener');
};

// Metin sunucudan geliyorsa: pencereyi tıklama anında aç (popup engeline takılmasın), sonra adresi ver
export const openMessageAfter = async (channel, loader) => {
  const win = channel === 'whatsapp' ? window.open('about:blank', '_blank') : null;
  try {
    const { phone, text } = await loader();
    const url = messageUrl(channel, phone, text);
    if (!url) throw new Error(NO_PHONE_MSG);
    if (win) win.location.href = url;
    else window.location.href = url;
  } catch (e) {
    if (win) win.close();
    throw e;
  }
};

export const tl = (n) => `${Number(n || 0).toLocaleString('tr-TR', { maximumFractionDigits: 2 })} TL`;
